export default __webpack_public_path__ + "static/media/116-lowfi-saigon.83b2950d.jpeg";